import React from 'react';

// Animated shine sweep across text — reactbits' ShinyText pattern, done with
// a moving background-position clipped to the glyphs (no extra deps).
// The sweep color defaults to a dark, opaque navy rather than white: white
// (even semi-transparent) all but disappears against this site's pale badge
// backgrounds since the fill is fully replaced by the gradient, not blended.
export function ShinyText({ text, className = '', speed = 3, highlightColor = '#0F1F3D', disabled = false }) {
  return (
    <span
      className={`shiny-text ${disabled ? '' : 'shiny-text-animated'} ${className}`}
      style={{ '--shine-speed': `${speed}s`, '--shine-highlight': highlightColor }}
    >
      {text}
    </span>
  );
}
